function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = {
    detail: data
  };
  var event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};
window.recentlyViewedIds = [];

if (!customElements.get('quantity-selector')) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.input = this.querySelector('.qty');
      this.step = parseFloat(this.input.getAttribute('step')) || 1;
      this.changeEvent = new Event('change', { bubbles: true });

      // Create buttons
      this.subtract = this.querySelector('.minus');
      this.add = this.querySelector('.plus');

      // Add functionality to buttons
      this.subtract.addEventListener('click', () => this.changeQuantity(-1 * this.step));
      this.add.addEventListener('click', () => this.changeQuantity(1 * this.step));

      this.classList.add('buttons_added');
      this.validateQtyRules();
    }
    changeQuantity(change) {
      let quantity = parseInt(this.input.value) || 0;

      // Update quantity
      const newValue = Math.max(quantity + change, 1);

      // Check min and max values
      const min = parseInt(this.input.min) || 1;
      const max = parseInt(this.input.max) || Infinity;
      if (newValue < min || newValue > max) return;

      // Update input value
      this.input.value = newValue;

      // Dispatch change event
      this.input.dispatchEvent(this.changeEvent);

      // Update button states
      this.validateQtyRules();
    }

    validateQtyRules() {
      const value = parseInt(this.input.value) || 0;
      const min = parseInt(this.input.min) || 1;
      const max = parseInt(this.input.max) || Infinity;

      this.subtract.classList.toggle('disabled', value <= min);
      this.add.classList.toggle('disabled', value >= max);
    }
  }

  customElements.define('quantity-selector', QuantityInput);
}

/**
 *  @class
 *  @function ProductCard
 */
if (!customElements.get('product-card')) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.swatches = this.querySelector('.product-card-swatches');
      this.image = this.querySelector('.product-card-image-link .product-primary-image');
      this.additional_images = this.querySelectorAll('.product-secondary-image');
      this.additional_images_nav = this.querySelectorAll('.product-secondary-images-nav li');
      this.quick_add = this.querySelector('.product-card--add-to-cart-button-simple');
    }
    connectedCallback() {
      if (this.swatches) {
        this.enableSwatches();
      }
      if (this.additional_images) {
        this.enableAdditionalImages();
      }
      if (this.quick_add) {
        this.enableQuickAdd();
      }
    }
    enableAdditionalImages() {
      let image_length = this.additional_images.length;
      let images = this.additional_images;
      let nav = this.additional_images_nav;
      let image_container = this.querySelector('.product-card-image');
      const mousemove = function (e) {
        let l = e.offsetX;
        let w = this.getBoundingClientRect().width;
        let prc = l / w;
        let sel = Math.floor(prc * image_length);
        let selimg = images[sel];
        images.forEach((image, index) => {
          if (image.classList.contains('hover')) {
            image.classList.remove('hover');
            if (nav.length) {
              nav[index].classList.remove('active');
            }
          }
        });
        if (selimg) {
          if (!selimg.classList.contains('hover')) {
            selimg.classList.add('hover');
            if (nav.length) {
              nav[sel].classList.add('active');
            }
          }
        }

      };
      const mouseleave = function (e) {
        images.forEach((image, index) => {
          image.classList.remove('hover');
          if (nav.length) {
            nav[index].classList.remove('active');
          }
        });
      };
      if (image_container) {
        image_container.addEventListener('touchstart', mousemove, {
          passive: true
        });
        image_container.addEventListener('touchmove', mousemove, {
          passive: true
        });
        image_container.addEventListener('touchend', mouseleave, {
          passive: true
        });
        image_container.addEventListener('mouseenter', mousemove, {
          passive: true
        });
        image_container.addEventListener('mousemove', mousemove, {
          passive: true
        });
        image_container.addEventListener('mouseleave', mouseleave, {
          passive: true
        });
      }

      window.addEventListener('load', () => {
        images.forEach(function (image) {
          lazySizes.loader.unveil(image);
        });
      });

    }
    enableSwatches() {
      let swatch_list = this.swatches.querySelectorAll('.product-card-swatch');
      this.color_index = this.swatches.dataset.index;
      this.org_srcset = this.image ? this.image.dataset.srcset : '';

      this.addEventListener('change', this.onSwatchChange.bind(this));

      swatch_list.forEach((swatch) => {
        window.addEventListener('load', () => {
          let image = new Image();
          image.srcset = swatch.dataset.srcset;
          lazySizes.loader.unveil(image);
        });

        // ★ 修正ポイント：click をインラインで上書き
        swatch.addEventListener('click', function (e) {
          // 親リンクや href="#" による「先頭ジャンプ」を防ぐ
          e.preventDefault();
          e.stopPropagation();

          const href = this.dataset.href;
          if (!href) return;

          window.location.assign(href);
        });

        // hover挙動はそのまま
        swatch.addEventListener('mouseover', this.onSwatchHover);
      });
    }
    onSwatchClick() {
      window.location.href = this.dataset.href;
    }
    onSwatchHover() {
      let swatch_input = this.previousElementSibling;
      swatch_input.checked = true;
      swatch_input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    onSwatchChange(evt) {
      if (this.image) {
        if (evt.target.dataset.srcset) {
          this.image.setAttribute('srcset', evt.target.dataset.srcset);
        } else {
          this.image.setAttribute('srcset', this.org_srcset);
        }
      }
    }
    enableQuickAdd() {
      this.quick_add.addEventListener('click', this.quickAdd.bind(this));
    }
    quickAdd(evt) {
      evt.preventDefault();
      if (this.quick_add.disabled) {
        return;
      }
      this.quick_add.classList.add('loading');
      this.quick_add.setAttribute('aria-disabled', true);

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };

      let formData = new FormData();

      formData.append('id', this.quick_add.dataset.productId);
      formData.append('quantity', 1);
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);

      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return;
          }
          this.renderContents(response);
          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.quick_add.classList.remove('loading');
          this.quick_add.removeAttribute('aria-disabled');
        });

      return false;
    }
    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-secondary-area--item-count'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-secondary-area--item-amount'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
      }));


      if (document.getElementById('Cart-Drawer')) {
        document.getElementById('Cart-Drawer').open();
        document.getElementById('Cart-Drawer').removeProductEvent();
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector)?.innerHTML;
    }
  }
  customElements.define('product-card', ProductCard);
}

/**
 *  @class
 *  @function PanelClose
 */
if (!customElements.get('side-panel-close')) {
  class PanelClose extends HTMLElement {

    constructor() {
      super();
      let cc = document.querySelector('.click-capture');

      // Add functionality to buttons
      this.addEventListener('click', (e) => this.close_panel(e));
      document.addEventListener('panel:close', (e) => {
        let panel = document.querySelectorAll('.side-panel.active');
        if (panel.length) {
          this.close_panel(e, panel[0]);
        }
      });
      cc.addEventListener('click', (e) => {
        let panel = document.querySelectorAll('.side-panel.active');
        if (panel) {
          this.close_panel(e, panel[0]);
        }
      });
    }

    close_panel(e, panel) {
      if (e) {
        e.preventDefault();
      }
      if (!panel) {
        panel = e?.target.closest('.side-panel');

        if (!panel) {
          return;
        }
      }
      panel.classList.remove('active');
      document.body.classList.remove('open-cc');
      panel.setAttribute('inert', '');
    }
  }
  customElements.define('side-panel-close', PanelClose);

  document.addEventListener('keyup', (e) => {
    if (e.code) {
      if (e.code.toUpperCase() === 'ESCAPE') {
        dispatchCustomEvent('panel:close');
      }
    }
  });
}
/**
 *  @class
 *  @function CartDrawer
 */
if (!customElements.get('cart-drawer')) {
  class CartDrawer extends HTMLElement {

    constructor() {
      super();
    }

    connectedCallback() {
      this.isOpen = false;
      this.button = document.getElementById('cart-drawer-toggle');

      this.debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, 300);

      document.addEventListener('cart:refresh', (event) => {
        this.refresh();
      });

      this.addEventListener('change', this.debouncedOnChange.bind(this));

      this.removeProductEvent();

      document.addEventListener('click', this.onWindowClick.bind(this));

      // Add functionality to button
      this.button.addEventListener('click', (e) => {
        e.preventDefault();
        this.isOpen ? this.close() : this.open();
      });

      document.addEventListener('keyup', (e) => {
        if (e.code) {
          if (e.code.toUpperCase() === 'ESCAPE') {
            this.close();
          }
        }
      });
    }

    onWindowClick(event) {
      if (!this.contains(event.target) && this.isOpen && !this.button.contains(event.target)) {
        this.close();
      }
    }
    open() {
      this.removeAttribute('inert');
      this.focus();
      this.isOpen = true;
      dispatchCustomEvent('cart-drawer:open');
    }
    close() {
      this.setAttribute('inert', '');
      this.isOpen = false;
    }
    onChange(event) {
      if (event.target.classList.contains('qty')) {
        this.updateQuantity(event.target.dataset.index, event.target.value);
      }
    }
    removeProductEvent() {

      let removes = this.querySelectorAll('.remove');

      removes.forEach((remove) => {
        remove.addEventListener('click', (event) => {
          this.updateQuantity(event.target.dataset.index, '0');
          event.preventDefault();
        });
      });
    }
    getSectionsToRender() {
      return [{
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer--inner'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-secondary-area--item-count'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-secondary-area--item-amount'
      }];
    }
    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector)?.innerHTML;
    }
    updateQuantity(line, quantity) {
      this.querySelector(`#CartDrawerItem-${line}`)?.classList.add('thb-loading');
      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });

      dispatchCustomEvent('line-item:change:start', {
        quantity: quantity
      });

      fetch(`${theme.routes.cart_change_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        ...{
          body
        }
      })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);

          this.getSectionsToRender().forEach((section => {
            const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

            if (parsedState.sections) {
              elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            }
          }));

          this.removeProductEvent();
          dispatchCustomEvent('line-item:change:end', {
            quantity: quantity,
            cart: parsedState
          });

          if (this.querySelector(`#CartDrawerItem-${line}`)) {
            this.querySelector(`#CartDrawerItem-${line}`).classList.remove('thb-loading');
          }
        });
    }
    refresh() {
      let sections = 'cart-drawer,cart-bubble';
      fetch(`${window.location.pathname}?sections=${sections}`)
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);

          this.getSectionsToRender().forEach((section => {
            const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState[section.section], section.selector);
          }));

          this.removeProductEvent();
        });
    }
  }
  customElements.define('cart-drawer', CartDrawer);
}

/**
 *  @class
 *  @function LocalizationForm
 */
if (!customElements.get('localization-form')) {
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.inputs = this.form.querySelectorAll('[name="locale_code"], [name="country_code"]');
      this.debouncedOnSubmit = debounce((event) => {
        this.onSubmitHandler(event);
      }, 200);
      this.inputs.forEach(item => item.addEventListener('change', this.debouncedOnSubmit.bind(this)));
    }
    onSubmitHandler(event) {
      if (this.form) this.form.submit();
    }
  }
  customElements.define('localization-form', LocalizationForm);
}

/**
 *  @class
 *  @function ResizeSelect
 */
if (!customElements.get('resize-select')) {
  class ResizeSelect extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.select = this.querySelector('select');
      this.addEventListeners();
    }
    addEventListeners() {
      this.addEventListener('change', this.resizeSelect.bind(this));
      window.addEventListener('load', this.resizeSelect.bind(this));
      this.resizeSelect();
    }
    resizeSelect() {
      let tempOption = document.createElement('option');
      tempOption.textContent = this.select.selectedOptions[0].textContent;

      let tempSelect = document.createElement('select'),
        offset = 10;
      tempSelect.style.visibility = 'hidden';
      tempSelect.style.position = 'fixed';
      tempSelect.appendChild(tempOption);
      this.after(tempSelect);
      if (tempSelect.clientWidth > 0) {
        this.select.style.width = `${+tempSelect.clientWidth + offset}px`;
      }
      tempSelect.remove();
    }
  }
  customElements.define('resize-select', ResizeSelect);
}

/**
 *  @class
 *  @function QuickView
 */
if (!customElements.get('quick-view')) {
  class QuickView extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.drawer = document.getElementById('Product-Modal');
      this.body = document.body;

      this.addEventListener('click', this.setupEventListener.bind(this));
      this.addEventListener('keypress', this.setupEventListener.bind(this));
    }
    setupEventListener(e) {
      if (e.key && e.key !== 'Enter') {
        return;
      }
      e.preventDefault();
      let productHandle = this.dataset.productHandle,
        href = `${theme.routes.root_url}/products/${productHandle}?view=quick-view`;

      // remove double `/` in case shop might have /en or language in URL
      href = href.replace('//', '/');
      if (!href || !productHandle) {
        return;
      }
      if (this.classList.contains('loading')) {
        return;
      }
      this.classList.add('loading');
      fetch(href, {
        method: 'GET'
      })
        .then((response) => {
          this.classList.remove('loading');
          return response.text();
        })
        .then(text => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#Product-Modal-Content').innerHTML;
          this.renderQuickview(sectionInnerHTML, href, productHandle);
        });
    }
    renderQuickview(sectionInnerHTML, href, productHandle) {
      if (sectionInnerHTML) {
        this.drawer.querySelector('#Product-Modal-Content').innerHTML = sectionInnerHTML;

        let js_files = this.drawer.querySelector('#Product-Modal-Content').querySelectorAll('script');

        if (js_files.length > 0) {
          var head = document.getElementsByTagName('head')[0];
          js_files.forEach((js_file, i) => {
            let script = document.createElement('script');
            script.src = js_file.src;
            head.appendChild(script);
          });
        }

        setTimeout(() => {
          if (Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
          if (window.ProductModel) {
            window.ProductModel.loadShopifyXR();
          }
        }, 300);

        this.drawer.setAttribute('open', '');
        this.drawer.querySelector('.product-modal__toggle').focus();

        setTimeout(() => {
          let slider = this.drawer.querySelector('#Product-Slider');

          slider.reInit();
          window.dispatchEvent(new Event('resize'));
        }, 100);

        dispatchCustomEvent('quick-view:open', {
          productUrl: href,
          productHandle: productHandle
        });
        addIdToRecentlyViewed(productHandle);
      }
    }
  }
  customElements.define('quick-view', QuickView);
}

/**
 *  @class
 *  @function ThemeScroll
 */
if (!customElements.get('theme-scroll')) {
  class ThemeScroll extends HTMLElement {
    constructor() {
      super();

      this.viewport = this.querySelector('.theme-scroll--inner');
      this.slideWidth = 274;
      this.slidesToScroll = 1;
    }
    connectedCallback() {
      window.OverlayScrollbarsGlobal.OverlayScrollbars({
        target: this,
        elements: {
          viewport: this.viewport,
        }
      }, {});

      this.init();
    }
    init() {
      this.setSlides();
      this.reachedEnd = 0;

      if (this.slides.length < 1) {
        return;
      }
      this.nav = this.querySelector('.theme-scroll-nav');
      this.navPrev = this.querySelector('.flickity-prev');
      this.navNext = this.querySelector('.flickity-next');
      this.resizeObserver = new ResizeObserver((entries) => {
        this.slideWidth = this.slides[1].offsetLeft - this.slides[0].offsetLeft;
        this.reachedEnd = this.viewport.scrollWidth - this.viewport.offsetWidth == this.viewport.scrollLeft;
        this.onNavDisabled();
      }, {
        root: this
      });
      this.debouncedOnScroll = debounce((event) => {
        this.onScroll(event);
      }, 100);

      this.setListeners();
      this.centerArrows();
    }
    setSlides() {
      this.slides = this.querySelectorAll('.carousel__slide');
      this.slidesLength = this.slides.length;
      this.lastSlide = this.slides[this.slides.length - 1];
    }
    setListeners() {
      this.nav.addEventListener('click', this.onNavClick.bind(this));
      this.viewport.addEventListener('scroll', this.debouncedOnScroll.bind(this));
      this.viewport.addEventListener('resize', this.debouncedOnScroll.bind(this));
      this.resizeObserver.observe(this.slides[0]);
    }
    onScroll() {
      this.reachedEnd = this.viewport.scrollWidth - this.viewport.offsetWidth == Math.floor(this.viewport.scrollLeft);
      this.onNavDisabled();
    }
    onNavClick(e) {
      if (!e.target.matches('.flickity-nav')) {
        return;
      }
      if (e.target.name === 'next') {
        this.scrollPos = this.viewport.scrollLeft + this.slidesToScroll * this.slideWidth;
      } else if (e.target.name === 'prev') {
        this.scrollPos = this.viewport.scrollLeft - this.slidesToScroll * this.slideWidth;
      }
      this.viewport.scrollTo({
        left: this.scrollPos,
        behavior: "smooth"
      });
    }
    onNavDisabled() {
      if (this.navPrev) {
        this.navPrev.disabled = this.viewport.scrollLeft === 0 ? 1 : 0;
      }
      if (this.navNext) {
        this.navNext.disabled = this.reachedEnd ? 1 : 0;
      }
    }
    centerArrows() {
      let first_cell = this.slides[0],
        max_height = 0,
        image_height = 0;
      if (first_cell.querySelector('.product-card-image')) {
        image_height = first_cell.querySelector('.product-card-image').clientHeight;
      } else if (first_cell.querySelector('.gallery--item')) {
        image_height = this.slides[1].querySelector('.product-card-image').clientHeight;
      }
      if (image_height > 0) {
        this.slides.forEach((item, i) => {
          if (item.clientHeight > max_height) {
            max_height = item.clientHeight;
          }
        });

        if (max_height > image_height) {
          let difference = (max_height - image_height) / -2;

          this.navPrev.style.transform = 'translateY(' + difference + 'px)';
          this.navNext.style.transform = 'translateY(' + difference + 'px)';
        }
      }
    }
  }
  customElements.define('theme-scroll', ThemeScroll);
}

/**
 *  @class
 *  @function CollapsibleRow
 */
if (!customElements.get('collapsible-row')) {
  // https://css-tricks.com/how-to-animate-the-details-element/
  class CollapsibleRow extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.content = this.querySelector('.collapsible__content');
      this.collapsed_mobile = this.classList.contains('accordion--collapsed-mobile');

      // Store the animation object (so we can cancel it if needed)
      this.animation = null;
      // Store if the element is closing
      this.isClosing = false;
      // Store if the element is expanding
      this.isExpanding = false;
    }
    connectedCallback() {
      this.setListeners();
    }
    setListeners() {
      if (this.initialized) { return; }
      this.querySelector('summary').addEventListener('click', (e) => this.onClick(e));

      this.initialized = true;
      if (this.collapsed_mobile) {
        window.addEventListener('resize', () => {
          this.details.open = window.innerWidth > 768;
        });
        window.dispatchEvent(new Event('resize'));
      }
    }
    onClick(e) {
      // Stop default behaviour from the browser
      e.preventDefault();
      // Add an overflow on the <details> to avoid content overflowing
      this.details.style.overflow = 'hidden';

      // Check if the element is being closed or is already closed
      if (this.isClosing || !this.details.open) {
        this.open();
        // Check if the element is being openned or is already open
      } else if (this.isExpanding || this.details.open) {
        this.shrink();
      }
    }
    shrink() {
      // Set the element as "being closed"
      this.isClosing = true;

      // Store the current height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the height of the summary
      const endHeight = `${this.summary.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 250,
        easing: 'ease'
      });

      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(false);
      // If the animation is cancelled, isClosing variable is set to false
      this.animation.oncancel = () => this.isClosing = false;
    }

    open() {
      // Apply a fixed height on the element
      this.details.style.height = `${this.details.offsetHeight}px`;
      // Force the [open] attribute on the details element
      this.details.open = true;
      // Wait for the next frame to call the expand function
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      // Set the element as "being expanding"
      this.isExpanding = true;
      // Get the current fixed height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the open height of the element (summary height + content height)
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 250,
        easing: 'ease-out'
      });
      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(true);
      // If the animation is cancelled, isExpanding variable is set to false
      this.animation.oncancel = () => this.isExpanding = false;
    }

    onAnimationFinish(open) {
      // Set the open attribute based on the parameter
      this.details.open = open;
      // Clear the stored animation
      this.animation = null;
      // Reset isClosing & isExpanding
      this.isClosing = false;
      this.isExpanding = false;
      // Remove the overflow hidden and the fixed height
      this.details.style.height = this.details.style.overflow = '';

      this.dispatchEvent(new Event('animationend', { bubbles: false }));
    }
  }
  customElements.define('collapsible-row', CollapsibleRow);
}

/**
 *  @function addIdToRecentlyViewed
 */
function addIdToRecentlyViewed(handle) {
  if (!handle) {
    let product = document.querySelector('.thb-product-detail');

    if (product) {
      handle = product.dataset.handle;

    }
  }
  if (!handle) {
    return;
  }
  if (window.localStorage) {
    let recentIds = window.localStorage.getItem('recently-viewed');
    if (recentIds && typeof (recentIds) !== undefined) {
      window.recentlyViewedIds = JSON.parse(recentIds);
    }
  }
  // Remove current product if already in recently viewed array
  var i = window.recentlyViewedIds.indexOf(handle);

  if (i > -1) {
    window.recentlyViewedIds.splice(i, 1);
  }

  // Add id to array
  window.recentlyViewedIds.unshift(handle);

  if (window.localStorage) {
    window.localStorage.setItem('recently-viewed', JSON.stringify(window.recentlyViewedIds));
  }
}
window.addIdToRecentlyViewed = addIdToRecentlyViewed;

document.addEventListener("DOMContentLoaded", function () {
  const OFFSET_PC = 250;
  const OFFSET_SP = 320; // スマホ用に少し低めに
  const links = document.querySelectorAll(".alphabet-link");

  function getOffset() {
    return window.innerWidth <= 768 ? OFFSET_SP : OFFSET_PC;
  }

  function setCurrentLink(targetId) {
    links.forEach((link) => {
      link.classList.remove("link-current");
      if (link.getAttribute("href") === `#${targetId}`) {
        link.classList.add("link-current");
      }
    });
  }

  links.forEach((link) => {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      const targetId = this.getAttribute("href").substring(1);
      const target = document.getElementById(targetId);
      if (target) {
        const elementPosition =
          target.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = elementPosition - getOffset();
        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
        setCurrentLink(targetId);
      }
    });
  });
});

// document.addEventListener("DOMContentLoaded", function () {
//   const header = document.querySelector("header");
//   const alphabetNav = document.querySelector(".alphabet-links-wrapper");
//   const offset =
//     (header?.offsetHeight || 0) + (alphabetNav?.offsetHeight || 0) + 10; // 余白込み

//   document.querySelectorAll(".alphabet-link").forEach((link) => {
//     link.addEventListener("click", function (e) {
//       e.preventDefault();

//       const targetId = link.getAttribute("href").replace("#", "");
//       const target = document.getElementById(targetId);
//       if (!target) return;

//       const top = target.getBoundingClientRect().top + window.scrollY - offset;

//       window.scrollTo({
//         top,
//         behavior: "smooth",
//       });
//     });
//   });
// });



document.addEventListener("DOMContentLoaded", function () {
  const tabButtons = document.querySelectorAll(".custom-tab-nav .tab-btn");
  const tabItems = document.querySelectorAll(".custom-tab-content .tab-item");

  // 初期アクティブ設定（アニメーションなし）
  tabButtons[0].classList.add("active");
  tabItems[0].classList.add("active", "show");

  tabButtons.forEach((btn, index) => {
    btn.addEventListener("click", () => {
      // タブボタンの切替
      tabButtons.forEach((b) => b.classList.remove("active"));
      btn.classList.add("active");

      // タブ内容の切替（アニメーション付き）
      tabItems.forEach((item, i) => {
        item.classList.remove("active", "show");
        if (i === index) {
          item.classList.add("active");
          // 1秒後にふわっと表示
          setTimeout(() => {
            item.classList.add("show");
          }, 300);
        }
      });
    });
  });
});

// ドロワー内スクロール維持 + 同階層は常に1つだけ開く（2階層/3階層対応）
// ※ click(キャプチャ)のみで処理。pointerdownは使わない＝ドラッグスクロールと競合しない
document.addEventListener("DOMContentLoaded", () => {
  const menu = document.querySelector("#mobile-menu");
  if (!menu) return;
  // Prevent multiple initializations (e.g., section re-renders)
  if (window.__mobileMenuAccordionApplied) return;
  window.__mobileMenuAccordionApplied = true;

  const level2 =
    "#mobile-menu .sub-menu > li > details.link-container > summary";
  const level3 =
    "#mobile-menu .sub-menu > li > details.link-container .sub-menu > li > details.link-container > summary";
  const summarySelector = `${level2}, ${level3}`;

  const getScrollContainer = (el) => {
    let n = el;
    while (n) {
      const cs = getComputedStyle(n);
      if (
        /(auto|scroll|overlay)/.test(cs.overflowY) &&
        n.scrollHeight > n.clientHeight
      )
        return n;
      n = n.parentElement;
    }
    return (
      document.querySelector("#mobile-menu .mobile-menu-drawer--inner") ||
      document.scrollingElement
    );
  };

  // 1) summary上の click をキャプチャ段階で握る → UAのデフォルト(toggle)を止めて手動で処理
  menu.addEventListener(
    "click",
    (e) => {
      const summary = e.target.closest(summarySelector);
      if (!summary) return;

      // ネイティブのdetailsトグルを止める（これで二度トグルしない）
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();

      const details = summary.parentElement;
      const sc = getScrollContainer(details);

      // 開く前の相対位置（ドロワー内）を記録
      const scRect = sc.getBoundingClientRect();
      const beforeTop = summary.getBoundingClientRect().top - scRect.top;
      const beforeScrollTop = sc.scrollTop;

      // 同じ .sub-menu 直下は常に1つだけ開く
      const group = details.closest(".sub-menu");
      if (group) {
        group
          .querySelectorAll(":scope > li > details.link-container[open]")
          .forEach((other) => {
            if (other !== details) other.open = false;
          });
      }

      // 自分を手動でトグル
      details.open = !details.open;

      // レイアウト確定後に「開いた summary を画面上端」に合わせる
      requestAnimationFrame(() => {
        try { summary.focus({ preventScroll: true }); } catch {}

        // CSS変数 --header-offset をpxとして取得（なければ0）
        const getCssVarPx = (name, fallback = 0) => {
          const v = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
          const n = parseInt(v, 10);
          return Number.isFinite(n) ? n : fallback;
        };
        const headerOffset = getCssVarPx('--header-offset', 0);
        const extra = 8; // 少しだけ余白
        const offset = headerOffset + extra;

        const scRectNow = sc.getBoundingClientRect();
        const topInScroller = summary.getBoundingClientRect().top - scRectNow.top;
        const clamp = (v, lo, hi) => Math.max(lo, Math.min(v, hi));
        const max = Math.max(0, sc.scrollHeight - sc.clientHeight);

        // 1回目：直後に上端へ
        const target = clamp(sc.scrollTop + topInScroller - offset, 0, max);
        sc.scrollTop = target;

        // 2回目：遅延読込やアニメで高さが変わった場合の追随
        requestAnimationFrame(() => {
          const scRect2 = sc.getBoundingClientRect();
          const top2 = summary.getBoundingClientRect().top - scRect2.top;
          const target2 = clamp(sc.scrollTop + top2 - offset, 0, Math.max(0, sc.scrollHeight - sc.clientHeight));
          sc.scrollTop = target2;
        });
      });
    },
    true
  ); // ← capture = true が重要

  // 2) キーボード操作（Enter/Space）も同じ挙動に
  menu.addEventListener("keydown", (ev) => {
    const summary = ev.target.closest(summarySelector);
    if (!summary) return;
    if (ev.key !== "Enter" && ev.key !== " ") return;
    ev.preventDefault();
    // 上のclick(キャプチャ)を再利用
    summary.dispatchEvent(
      new MouseEvent("click", { bubbles: true, cancelable: true })
    );
  });

  // 3) summary内の "#" アンカーのジャンプ抑止（保険）
  menu.addEventListener("click", (e) => {
    const a = e.target.closest("summary a[href='#']");
    if (a) e.preventDefault();
  });

  // 4) 内側スクロールを安定化（最小限：レイアウトを壊さない）
  const inner = document.querySelector(
    "#mobile-menu .mobile-menu-drawer--inner"
  );
  if (inner) {
    inner.style.removeProperty("height");
    inner.style.overflowY = "auto";
    inner.style.overscrollBehavior = "contain";
    inner.style.webkitOverflowScrolling = "touch";
  }

  // 5) ドロワーが閉じられたら、開いている <details> を全て閉じる（状態リセット）
  const toggleWrapper = document.querySelector(".mobile-toggle-wrapper");
  const resetOpenDetails = () => {
    menu
      .querySelectorAll("details.link-container[open]")
      .forEach((d) => (d.open = false));
  };

  if (toggleWrapper) {
    const mo = new MutationObserver(() => {
      const isOpen = toggleWrapper.classList.contains("active");
      if (!isOpen) {
        // 閉じた瞬間にリセット（次回オープン時のチラつき防止）
        resetOpenDetails();
      }
    });
    mo.observe(toggleWrapper, { attributes: true, attributeFilter: ["class"] });
  }

  // 念のため、メニュー自体が hidden になったときも閉じる
  menu.addEventListener("transitionend", () => {
    const styles = getComputedStyle(menu);
    const hidden =
      styles.visibility === "hidden" ||
      styles.display === "none" ||
      styles.opacity === "0";
    if (hidden) resetOpenDetails();
  });
});

(function () {
  // ---- Guards: safe operation ----
  // 1) prevent multiple application (e.g., theme hot-reload / section re-render)
  if (window.__klReviewScrollPatchApplied) return;
  window.__klReviewScrollPatchApplied = true;

  // 2) scope to pages that actually have review context
  //    If neither the trigger button nor any target exists at this moment,
  //    exit early to avoid attaching global capture listeners site-wide.
  (function(){
    const hasButton = !!document.querySelector('.kl_reviews__star_rating_widget');
    const hasTarget = !!document.querySelector('#reviews_all_container, .kl_reviews_summary, #kl_reviews__summary, .kl_reviews__summary__header');
    if (!hasButton && !hasTarget) {
      // If later in the lifecycle the widget gets injected, hashchange will still be handled below.
      return;
    }
  })();

  const EXTRA_OFFSET = 12; // 見やすくする余白
  const TARGET_SELECTORS = [
    "#reviews_all_container",
    ".kl_reviews_summary",
    "#kl_reviews__summary",
    ".kl_reviews__summary__header",
  ];
  const BUTTON_SELECTOR = ".kl_reviews__star_rating_widget";

  function cssVarPx(name, fallback = 0) {
    const v = getComputedStyle(document.documentElement)
      .getPropertyValue(name)
      .trim();
    const n = parseInt(v, 10);
    return Number.isFinite(n) ? n : fallback;
  }

  function getHeaderHeight() {
    // テーマで使っている --header-height を優先
    return cssVarPx("--header-height", 0);
  }

  function findTarget() {
    for (const sel of TARGET_SELECTORS) {
      const el = document.querySelector(sel);
      if (el) return el;
    }
    return null;
  }

  function smoothScrollToTarget() {
    const target = findTarget();
    if (!target) return;

    const header = getHeaderHeight();
    const offset = header + EXTRA_OFFSET;

    // スクロール元が window 以外のケースにも対応
    // 最も近いスクロールコンテナを探す
    let scroller = document.scrollingElement || document.documentElement;
    let node = target.parentElement;
    while (node && node !== document.body) {
      const style = getComputedStyle(node);
      const canScroll = /(auto|scroll|overlay)/.test(style.overflowY);
      if (canScroll) {
        scroller = node;
        break;
      }
      node = node.parentElement;
    }

    const rect = target.getBoundingClientRect();
    const currentTop =
      scroller === document.documentElement || scroller === document.body
        ? window.pageYOffset
        : scroller.scrollTop;

    const absoluteTop = currentTop + rect.top;
    const to = Math.max(absoluteTop - offset, 0);

    if (scroller === document.documentElement || scroller === document.body) {
      window.scrollTo({ top: to, behavior: "smooth" });
    } else {
      scroller.scrollTo({ top: to, behavior: "smooth" });
    }
  }

  // クリック系をキャプチャ段階で先取りして既定動作を抑止
  const EVENTS = ["pointerdown", "mousedown", "touchstart", "click"];
  function intercept(e) {
    const btn = e.target.closest(BUTTON_SELECTOR);
    if (!btn) return;
    try {
      // 既存ハンドラより先に止める
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      // レイアウト確定後にスクロール（2フレーム待つと安定）
      requestAnimationFrame(() => requestAnimationFrame(smoothScrollToTarget));
    } catch (err) {
      // Fail-safe: if anything goes wrong, do not block original handlers
      console.error('[reviews-scroll-guard] intercept error', err);
    }
    return;
  }
  EVENTS.forEach((ev) =>
    window.addEventListener(ev, intercept, { capture: true, passive: false })
  );

  // ハッシュ書き換えで飛ばす実装にも対応
  window.addEventListener(
    "hashchange",
    () => {
      // レビュー系のハッシュだった場合のみ上書き
      const h = location.hash || "";
      if (/review/i.test(h)) {
        requestAnimationFrame(() =>
          requestAnimationFrame(smoothScrollToTarget)
        );
      }
    },
    { passive: true }
  );

  // ウィジェット再描画に強い：ボタンの出入りを監視（任意）
  const mo = new MutationObserver(() => {
    /* 何もしない。イベントは委譲済み */
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();

(function () {
  var ENABLE_MIN_WIDTH = 1024; // PCのみ
  var STEP = 400; // 1回のスクロール量(px) ← 前より大きめで「いい感じ」に

  function setup(el) {
    if (!el || el.closest(".collection-tabs--with-arrows")) return;

    var wrapper = document.createElement("div");
    wrapper.className = "collection-tabs--with-arrows";

    var prev = document.createElement("button");
    prev.type = "button";
    prev.className = "collection-tabs__arrow collection-tabs__arrow--prev";
    prev.setAttribute("aria-label", "Scroll left");
    // 左矢印（SVG）
    const LEFT_SVG = `
      <svg width="8" height="14" viewBox="0 0 8 14" fill="none" aria-hidden="true" focusable="false">
        <path d="M6.5 1.25L1.25 7L6.5 12.75"
          stroke="currentColor" stroke-width="1.0"
          stroke-linecap="round" stroke-linejoin="round"/>
      </svg>`;
    prev.innerHTML = LEFT_SVG;

    var next = document.createElement("button");
    next.type = "button";
    next.className = "collection-tabs__arrow collection-tabs__arrow--next";
    next.setAttribute("aria-label", "Scroll right");
    // 右矢印（SVG）
    const RIGHT_SVG = `
      <svg width="8" height="14" viewBox="0 0 8 14" fill="none" aria-hidden="true" focusable="false">
        <path d="M1.5 1.25L6.75 7L1.5 12.75"
          stroke="currentColor" stroke-width="1.0"
          stroke-linecap="round" stroke-linejoin="round"/>
      </svg>`;
    next.innerHTML = RIGHT_SVG;

    var parent = el.parentNode;
    parent.insertBefore(wrapper, el);
    wrapper.appendChild(prev);
    wrapper.appendChild(el);
    wrapper.appendChild(next);

    function updateEdge() {
      var maxScroll = el.scrollWidth - el.clientWidth;
      var x = el.scrollLeft;

      // disabled属性ではなくクラスで制御
      if (x <= 0) {
        prev.classList.add("is-disabled");
      } else {
        prev.classList.remove("is-disabled");
      }
      if (x >= maxScroll - 1) {
        next.classList.add("is-disabled");
      } else {
        next.classList.remove("is-disabled");
      }
    }

    function scrollBy(dx) {
      try {
        el.scrollBy({ left: dx, behavior: "smooth" });
      } catch (e) {
        el.scrollLeft += dx;
      }
    }

    prev.addEventListener("click", function () {
      scrollBy(-STEP);
    });
    next.addEventListener("click", function () {
      scrollBy(+STEP);
    });

    el.addEventListener("scroll", updateEdge);
    window.addEventListener("resize", updateEdge);
    updateEdge();
  }

  function init() {
    if (window.innerWidth < ENABLE_MIN_WIDTH) return;
    var lists = document.querySelectorAll(".collection-tabs__list");
    (lists.forEach ? lists : Array.prototype.slice.call(lists)).forEach(setup);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

document.addEventListener("DOMContentLoaded", () => {
  const select = document.getElementById("header-search-select");
  if (!select) return;

  // 幅反映をできるだけ早く（視覚遅延を抑える）
  select.style.transition = 'width 80ms linear';

  const ARROW_EXTRA = 14; // ▼アイコン分の最小余白（やや控えめ）
  const RIGHT_TRIM = 8;  // 右側をわずかに詰める（見た目の余白を最小化）

  // 計測用の不可視spanを1個だけ使い回す
  const meter = document.createElement("span");
  meter.style.cssText = [
    "position:absolute",
    "visibility:hidden",
    "white-space:nowrap",
    "left:-9999px",
    "top:-9999px",
    "pointer-events:none",
  ].join(";");
  document.body.appendChild(meter);

  function px(v) {
    return Number.parseFloat(v) || 0;
  }

  function applySameTypography(from, toSpan) {
    const cs = getComputedStyle(from);
    // 幅に影響するプロパティだけコピー
    toSpan.style.fontFamily = cs.fontFamily;
    toSpan.style.fontSize = cs.fontSize;
    toSpan.style.fontWeight = cs.fontWeight;
    toSpan.style.fontStyle = cs.fontStyle;
    toSpan.style.letterSpacing = cs.letterSpacing;
    toSpan.style.textTransform = cs.textTransform;
  }

  // --- box-sizeをキャッシュ（毎回reflowしない） ---
  let basePadW = 0, baseBorderW = 0;
  function computeBox() {
    const cs = getComputedStyle(select);
    basePadW = px(cs.paddingLeft) + px(cs.paddingRight);
    baseBorderW = px(cs.borderLeftWidth) + px(cs.borderRightWidth);
    applySameTypography(select, meter);
  }
  computeBox();

  function resizeToSelected() {
    const text = select.options[select.selectedIndex]?.text ?? "";

    // フォントやtypographyはcomputeBoxで既に反映
    meter.textContent = text;

    const textW = Math.ceil(meter.getBoundingClientRect().width);
    const padW = basePadW;
    const borderW = baseBorderW;

    const width = Math.max(textW + padW + borderW + ARROW_EXTRA - RIGHT_TRIM, textW + padW + borderW + 2);
    select.style.width = width + "px";
  }

  // 初期・変更時・リサイズ時・フォント読み込み後に実行
  resizeToSelected();

  // キー操作（上下/ホーム/エンド/ページ）で即時に追従
  select.addEventListener('keydown', (e) => {
    if (['ArrowUp','ArrowDown','Home','End','PageUp','PageDown'].includes(e.key)) {
      // レンダリング直後に幅再計算
      requestAnimationFrame(resizeToSelected);
    }
  });
  // クリックやマウスアップでも即時追従（ブラウザ差対策）
  select.addEventListener('click', () => requestAnimationFrame(resizeToSelected));
  select.addEventListener('mouseup', () => requestAnimationFrame(resizeToSelected));

  select.addEventListener("change", resizeToSelected);
  select.addEventListener("input", resizeToSelected);
  window.addEventListener("resize", () => { computeBox(); resizeToSelected(); });
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(() => { computeBox(); resizeToSelected(); }).catch(() => {});
  }
});
(function () {
  if (!window.__enableCartAutoReload) {
    // Auto-reload on cart change is disabled by default to prevent cart drawer from closing after quantity updates.
    return;
  }
  // 二重リロード防止
  let reloading = false;
  function safeReload() {
    if (reloading) return;
    reloading = true;
    location.reload();
  }

  // cart 更新に該当するパスを判定
  function isCartUpdateURL(url) {
    try {
      const u = String(url);
      return /\/cart\/(change|update|change\.js|update\.js)/.test(u);
    } catch {
      return false;
    }
  }

  // fetch をフック：/cart/change(.js)|/cart/update(.js) のレスポンスが返ってきたらリロード
  const origFetch = window.fetch;
  window.fetch = function (input, init) {
    const url = typeof input === "string" ? input : input && input.url;
    const method =
      init && (init.method || init.type)
        ? String(init.method || init.type).toUpperCase()
        : "GET";
    const willUpdate = isCartUpdateURL(url) && method !== "GET";
    return origFetch.apply(this, arguments).then(function (res) {
      if (willUpdate) {
        // サーバー反映が済んだタイミングで即リロード
        Promise.resolve().then(safeReload);
      }
      return res;
    });
  };

  // XHR を使うテーマ向けフック
  const origOpen = XMLHttpRequest.prototype.open;
  const origSend = XMLHttpRequest.prototype.send;
  let _lastXHRUrl = "";
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__isCartUpdate =
      isCartUpdateURL(url) && String(method).toUpperCase() !== "GET";
    _lastXHRUrl = url;
    return origOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (this.__isCartUpdate) {
      this.addEventListener("load", function () {
        // 成功/失敗に関わらず返答を受けたらリロード（成功時は数量が確定している）
        safeReload();
      });
    }
    return origSend.apply(this, arguments);
  };

  // フォールバック：フォーム submit 経由の更新にも対応
  document.addEventListener(
    "submit",
    function (e) {
      const form = e.target;
      if (!form) return;
      const action = form.getAttribute("action") || "";
      if (/\/cart\/(change|update)/.test(action)) {
        // ネイティブ submit 完了後にリロード（即時だと POST がキャンセルされるため）
        setTimeout(safeReload, 50);
      }
    },
    true
  );

  // 既存の「数量変更で即リロード」系のコードが残っていたら削除/無効化してください
})();

// Narrower drawer width adjustment
(function(){
  var style = document.createElement('style');
  style.textContent = `
    .policy-drawer__panel {
      width: min(80vw, 600px) !important; /* narrower than original 90vw / 720px */
    }
    @media (min-width: 1024px) {
      .policy-drawer__panel {
        width: min(60vw, 480px) !important; /* even narrower on desktop */
      }
    }
  `;
  document.head.appendChild(style);
})();

// NOTE: do not early-return; we may open the existing site drawer instead and only use the policy drawer as a fallback.
(function () {
  var root = document.getElementById("policy-drawer");

  // ---- Fast path: in-memory cache & prefetch ----
  var __policyCache = window.__policyCache || (window.__policyCache = new Map());
  function policyCacheKey(url) { return url; }
  function setPolicyCache(url, html) { try { __policyCache.set(policyCacheKey(url), html); } catch(e) {} }
  function getPolicyCache(url) { try { return __policyCache.get(policyCacheKey(url)); } catch(e) { return undefined; } }
  function withIdle(cb){ if (window.requestIdleCallback) requestIdleCallback(cb, {timeout: 800}); else setTimeout(cb, 300); }

  // Try a lightweight drawer view first (?view=drawer), fall back to full page
  function loadPolicyHTML(url) {
    var cached = getPolicyCache(url);
    if (cached) return Promise.resolve(cached);

    var hasQuery = url.indexOf('?') >= 0;
    var drawerUrl = url + (hasQuery ? '&' : '?') + 'view=drawer';

    // 1) Try drawer view
    return fetch(drawerUrl, { credentials: "same-origin" })
      .then(function(res){
        if (!res.ok) throw new Error("no drawer view");
        return res.text();
      })
      .then(function(text){
        // Heuristic: drawer view should be small and contain some policy content marker if you add one later.
        // If it looks empty (very short), fall back.
        if (!text || text.replace(/\s+/g,'').length < 64) throw new Error("drawer too small");
        setPolicyCache(url, text);
        return text;
      })
      .catch(function(){
        // 2) Fallback to full page and extract body (existing logic path will handle)
        return fetch(url, { credentials: "same-origin" }).then(function(r){ return r.text(); });
      });
  }

  function prefetchPolicy(url){
    if (getPolicyCache(url)) return; // already prefetched
    withIdle(function(){
      loadPolicyHTML(url).then(function(text){
        // If we fetched full HTML (fallback path), do nothing here; parsing happens on open for now.
        // If it's a drawer view (already trimmed), cache as-is.
        setPolicyCache(url, text);
      }).catch(function(){ /* ignore */ });
    });
  }

  // Try to open the site's existing "Product-Information-Drawer" and switch to the Delivery tab.
  // Returns true if the drawer was opened (and tab selected), false otherwise.
  function openDeliveryInfoDrawer() {
    var drawer = document.getElementById('Product-Information-Drawer');
    if (!drawer) return false;

    // Open the drawer using existing theme conventions
    drawer.classList.add('active');
    document.body.classList.add('open-cc');
    drawer.removeAttribute('inert');

    // Attempt to select the "Delivery Information" tab/menu item.
    var candidate = Array.from(
      drawer.querySelectorAll('a,button,[data-target],[data-tab], .side-panel-heading, .h5.side-panel-heading')
    ).find(function(el){
      var txt = (el.textContent || '').trim();
      var data = (el.getAttribute('data-target') || el.getAttribute('data-tab') || '').trim();
      return /delivery information|delivery|配送|配達|送料/i.test(txt) || /delivery/i.test(data);
    });

    // Prevent default navigation if the candidate is an anchor
    if (candidate && candidate.tagName && candidate.tagName.toUpperCase() === 'A') {
      // Capture-phase, one-time preventDefault to allow JS handlers but block navigation
      var preventOnce = function(ev){
        try {
          ev.preventDefault();
          ev.stopPropagation();
          ev.stopImmediatePropagation();
        } catch(_) {}
        candidate.removeEventListener('click', preventOnce, true);
      };
      candidate.addEventListener('click', preventOnce, true);
    }

    if (candidate) {
      try { candidate.click(); } catch(e) {}
    }

    // Focus panel for accessibility
    var panel = drawer.querySelector('.side-panel-inner, .side-panel__panel, .side-panel-content');
    if (panel && panel.focus) panel.focus();

    return true;
  }

  function openDrawer() {
    root.hidden = false;
    requestAnimationFrame(function () {
      root.classList.add("is-open");
    });
    var panel = root.querySelector(".policy-drawer__panel");
    if (panel) panel.focus();
  }
  function closeDrawer() {
    root.classList.remove("is-open");
    setTimeout(function () {
      root.hidden = true;
    }, 250);
  }

  root.addEventListener("click", function (e) {
    if (e.target && e.target.hasAttribute("data-drawer-close")) closeDrawer();
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && !root.hidden) closeDrawer();
  });

  // 「Shipping calculated at checkout.」内のリンクだけを横取り
  document.addEventListener("click", function (e) {
    var a = e.target.closest(".product__tax a");
    if (!a) return;
    // 配送ポリシーへのリンクなら横取り
    if (!/\/policies\/shipping-policy(?:$|[?#])/.test(a.getAttribute("href")))
      return;

    e.preventDefault(); // 通常遷移を止める

    // 1) Prefer opening the site's existing "Delivery Information" drawer (exactly like the screenshot)
    if (openDeliveryInfoDrawer()) {
      return; // success → do not load policy page
    }

    // 2) Fallback to the policy drawer implementation if present; otherwise, final fallback to navigate
    var url = a.href;

    if (root) {
      openDrawer();
      var body = root.querySelector(".policy-drawer__body");
      body.innerHTML =
        '<div class="policy-drawer__loading" aria-live="polite">Loading…</div>';
    } else {
      // Final fallback: no custom drawer available
      window.location.href = url;
      return;
    }

    loadPolicyHTML(url)
      .then(function (html) {
        // If the cached/loaded HTML already looks like a trimmed drawer view, render it directly.
        var looksLikeFullDoc = /<!doctype|<html[\s>]/i.test(html);
        if (!looksLikeFullDoc) {
          body.innerHTML = html;
          // Ensure images do not block paint
          body.querySelectorAll('img').forEach(function(img){
            img.loading = img.loading || 'lazy';
            img.decoding = img.decoding || 'async';
            img.setAttribute('fetchpriority', 'low');
          });
          return;
        }

        // Otherwise parse and extract from full HTML
        var doc = new DOMParser().parseFromString(html, "text/html");
        var scope = doc.querySelector("#MainContent") || doc.querySelector("main") || doc.body;

        var content =
          scope.querySelector(".shopify-policy__body") ||
          scope.querySelector(".shopify-policy__container") ||
          scope.querySelector("[data-policy] .shopify-policy__body") ||
          scope.querySelector("[data-policy] .rte");

        if (!content) {
          var heading = Array.prototype.slice
            .call(scope.querySelectorAll("h1,h2"))
            .find(function (el) {
              return /shipping policy|配送ポリシー/i.test(el.textContent.trim());
            });
          if (heading) {
            var container = heading.closest("article,section,div");
            if (container) {
              content =
                container.querySelector(".shopify-policy__body, .rte, .content, article");
            }
          }
        }

        if (!content) {
          body.innerHTML =
            '<p>Could not parse policy content. <a href="' +
            url +
            '">Open full page</a></p>';
          return;
        }

        body.innerHTML = content.innerHTML;

        // After injecting, hint images to be non-blocking
        body.querySelectorAll('img').forEach(function(img){
          img.loading = img.loading || 'lazy';
          img.decoding = img.decoding || 'async';
          img.setAttribute('fetchpriority', 'low');
        });
      })
      .catch(function () {
        body.innerHTML =
          '<p>Failed to load. <a href="' + url + '">Open full page</a></p>';
      });
  });

  // ---- Prefetch triggers ----
  document.addEventListener('mouseover', function(e){
    var a = e.target.closest('.product__tax a[href*="/policies/shipping-policy"]');
    if (!a) return;
    prefetchPolicy(a.href);
  }, { passive: true });

  document.addEventListener('touchstart', function(e){
    var a = e.target.closest('.product__tax a[href*="/policies/shipping-policy"]');
    if (!a) return;
    prefetchPolicy(a.href);
  }, { passive: true });

  // Idle prefetch after load (first product view)
  withIdle(function(){
    var a = document.querySelector('.product__tax a[href*="/policies/shipping-policy"]');
    if (a) prefetchPolicy(a.href);
  });
})();

(function () {
  var overlay = document.getElementById("iwto-popup-{{ section.id }}");
  if (!overlay) return;
  var confirmBtn = document.getElementById(
    "iwto-popup-confirm-{{ section.id }}"
  );
  var cancelBtn = document.getElementById("iwto-popup-cancel-{{ section.id }}");
  var pendingHref = null;

  // Attach to buttons in this section only
  document
    .querySelectorAll(
      '[data-section-id="{{ section.id }}"][data-popup-trigger="true"]'
    )
    .forEach(function (el) {
      el.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        pendingHref = el.getAttribute("href") || el.getAttribute("data-href");
        overlay.style.display = "block";
        if (confirmBtn) confirmBtn.focus();
      });
    });

  if (confirmBtn)
    confirmBtn.addEventListener("click", function () {
      overlay.style.display = "none";
      if (pendingHref) window.location.href = pendingHref;
      pendingHref = null;
    });
  if (cancelBtn)
    cancelBtn.addEventListener("click", function () {
      overlay.style.display = "none";
      pendingHref = null;
    });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      overlay.style.display = "none";
      pendingHref = null;
    }
  });
})();
